import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../../services/api';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUsers, FiArrowRight, FiSearch } = FiIcons;

const ManageReports = () => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchTeams();
  }, []);

  const fetchTeams = async () => {
    setLoading(true);
    try {
      const response = await apiService.getTeams();
      setTeams(response.data || []);
    } catch (error) {
      console.error('Error fetching teams:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredTeams = teams.filter(team => 
    team.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-primary"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-lg font-medium text-gray-900">Team Reports</h2>
          <p className="mt-1 text-sm text-gray-500">
            Wählen Sie ein Team aus, um dessen Erfolgs-Timeline einzusehen.
          </p>
        </div>
      </div>

      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <SafeIcon icon={FiSearch} className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="text"
          placeholder="Teams suchen..."
          className="pl-10 block w-full shadow-sm focus:ring-brand-primary focus:border-brand-primary sm:text-sm border-gray-300 rounded-md p-2 border"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <ul className="divide-y divide-gray-200">
          {filteredTeams.length === 0 ? (
            <li className="px-6 py-4 text-center text-gray-500">
              Keine Teams gefunden.
            </li>
          ) : (
            filteredTeams.map((team) => (
              <li key={team.id}>
                <button
                  onClick={() => navigate(`/admin/reports/team/${team.id}`)}
                  className="block hover:bg-gray-50 w-full text-left focus:outline-none transition-colors"
                >
                  <div className="px-4 py-4 sm:px-6 flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="flex-shrink-0 bg-brand-primary/10 rounded-full p-2">
                        <SafeIcon icon={FiUsers} className="h-6 w-6 text-brand-primary" />
                      </div>
                      <div className="ml-4 truncate">
                        <div className="text-sm font-medium text-brand-primary truncate">{team.name}</div>
                        <div className="text-xs text-gray-500 mt-1">
                          ID: {team.id}
                        </div>
                      </div>
                    </div>
                    <div className="ml-2 flex-shrink-0 flex">
                      <SafeIcon icon={FiArrowRight} className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                </button>
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  );
};

export default ManageReports;